module.exports = __webpack_public_path__ + "static/img/mingtai.9af4971.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img/mingtai.png
// module id = awzi
// module chunks = 1